import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'cr-expandable-phone-number-list',
  styleUrl: 'cr-expandable-phone-number-list.css',
  shadow: true,
})
export class CrExpandablePhoneNumberList {
  /**
   * A list of strings, expected to be phone numbers
   */
  @Prop() phoneNumbers: Array<string> = []

  @State() showAdditionalPhoneNumbers: boolean = false

  render() {
    return (
      <div class="container">
        <div class="default-phone">
          <div class="default-phone-number">
            {this.phoneNumbers.length > 0 ? this.phoneNumbers[0] : ''}
          </div>
          {
            this.phoneNumbers.length > 1 ?
            (
              <div
                class="additional-phone-indicator"
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
              >
                (+{this.phoneNumbers.length - 1} more)
              </div>
            ) : <div></div>
          }
        </div>
        <div
          class={this.showAdditionalPhoneNumbers ? "additional-phone expanded" : "additional-phone"}
        >
          {
            this.phoneNumbers.length <= 1 ?
            (<div></div>) :
            (
              <bx-table>
                <bx-table-body>
                  {
                    this.phoneNumbers.slice(1).map((phoneNumber) => (
                      <bx-table-row>
                        <bx-table-cell>{phoneNumber}</bx-table-cell>
                      </bx-table-row>
                    ))
                  }
                </bx-table-body>
              </bx-table>
            )
          }
        </div>
      </div>
    )
  }

  private handleMouseOver = () => {
    this.showAdditionalPhoneNumbers = true
  }

  private handleMouseOut = () => {
    this.showAdditionalPhoneNumbers = false
  }

}
